import type { FC } from 'react';

import { Layout } from '@sravni/react-design-system/lib/Layout';
import { Space } from '@sravni/react-design-system/lib/Space';

import styles from './styles.module.scss';

type Props = {
  backgroundColor?: string;
};

export const OctoberPrizeDrawLayout: FC<Props> = ({ backgroundColor, children }) => (
  <Space style={{ backgroundColor }}>
    <Layout className={styles.layout}>{children}</Layout>
  </Space>
);
